/**
 * ==========================================================
 * TUUFAM - Custom JavaScript
 * ==========================================================
 */

document.addEventListener("DOMContentLoaded", () => {
  console.log("TUUFAM JS Loaded");
});

/**
 * ==========================================================
 * Hero Buttons Navigation
 * ==========================================================
 */
document.addEventListener("DOMContentLoaded", () => {
  const shopButton = document.querySelector('a[href="/#combo-collection"]');
  const storyButton = document.querySelector('a[href="#about-section"]');

  if (shopButton) {
    shopButton.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector("#combo-collection, .tuufam-featured-collection");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  }

  if (storyButton) {
    storyButton.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector("#about-section");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  }
});

/**
 * ==========================================================
 * Product Engine Foundation
 * ==========================================================
 */
document.addEventListener("DOMContentLoaded", () => {
  const productCards = document.querySelectorAll(".tuufam-product-card");
  window.tuufamProducts = [];

  productCards.forEach((card) => {
    const json = card.querySelector(".tuufam-product-data");
    if (!json) return;

    try {
      const product = JSON.parse(json.textContent);
      window.tuufamProducts.push({
        id: product.id,
        title: product.title,
        handle: product.handle,
        url: product.url,
        images: product.images || [],
        variants: product.variants || [],
        options: product.options || [],
        available: product.available,
        featuredImage: product.featured_image,
        price: product.price,
        compareAtPrice: product.compare_at_price,
        card: card,
      });
    } catch (e) {
      console.warn("Product JSON parse skipped");
    }
  });

  console.log("TUUFAM Product Engine Ready");
});